<template><div>
<div class="backServicesFijo"></div>
	<div class="services">
		<!--
		<div class="titulo">
			<span>
				<h1>Services</h1>
			</span>
		</div>
		-->

		<div class="serviceBox">

			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon01">
				</div>
				<h2 class="titulo">Are you looking for secure transportation?</h2>
				<h3 class="subtitulo">Transportation and protection for VIPs, CEOs and high-level executives.</h3>
				<router-link tag="li"  to="/executive-transportation-and-protection"><a class="read">read more</a></router-link>
			</div>

			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon04">
				</div>
				<h2 class="titulo">Do you need resources and security logistics for a large event?</h2>
				<h3 class="subtitulo">Transporation and Security Logistics for large special events.</h3>
				<router-link tag="li"  to="/security-logistics-for-events-and-productions"><a class="read">read more</a></router-link>
			</div>

			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon05">
				</div>
				<h2 class="titulo">How well do you know your present or future business associates?</h2>
				<h3 class="subtitulo">Background checks, and asset searches on associates or prospective partners </h3>
				<router-link tag="li"  to="/research-and-intelligence"><a class="read">read more</a></router-link>
			</div>

			<!--
			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon02">
				</div>
				<h2 class="titulo">Do you know how to act when facing a robbery?</h2>
				<h3 class="subtitulo">Prevention makes up for 90% of the security at home and outside. </h3>
				<router-link tag="li"  to="/talks-and-consultancies-on-personal-security"><a class="read">read more</a></router-link>
			</div>

			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon03">
				</div>
				<h2 class="titulo">Do you need guard supervision?</h2>
				<h3 class="subtitulo">Specialized and customized service in managing guards. </h3>
				<router-link tag="li"  to="/coverage-and-monitoring-for-guards"><a class="read">read more</a></router-link>
			</div>

			<div class="contenidoServices">
				<div class="icono">
					<img :src="icon06">
				</div>

				<h2 class="titulo">Is your company exposed to security risks?</h2>
				<h3 class="subtitulo">Security in your company is a matter of attitude. </h3>
				<router-link tag="li"  to="/consultancy-on-risks"><a class="read">read more</a></router-link>
			</div>
			-->
		</div> <!-- ServiceBox -->
	</div> <!-- services -->

</div></template>

<script>
import JQuery from 'jquery'
var $ = JQuery
import icono01 from '../assets/img/servicesSection/icono-1.png';
import icono02 from '../assets/img/servicesSection/icono-2.png';
import icono03 from '../assets/img/servicesSection/icono-3.png';
import icono04 from '../assets/img/servicesSection/icono-4.png';
import icono05 from '../assets/img/servicesSection/icono-5.png';
import icono06 from '../assets/img/servicesSection/icono-6.png';

export default {
	name: "ServicesComponent",
	data: function() {
		return {
			icon01: icono01,
			icon02: icono02,
			icon03: icono03,
			icon04: icono04,
			icon05: icono05,
			icon06: icono06,
		};
	},
	
	mounted() {
		this.$nextTick(() => {
			// Menu-toggle button

			$(document).ready(function() {
				// let alto = $(window).height();
				//console.log("la altura de la pagina desde servicios es " + alto)
				//  $(".services").css('top', alto+50+'px');				 

				// let alturaServiceBox = $(".serviceBox").css("height");
				//console.log("lectura de alto de serviceBox " + alturaServiceBox+'px');

				//$(".backServicesFijo").css('top', alturaServiceBox);

			});
		});
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import url('../assets/less/soloVariables.less');

////////// Services

body, html {
	min-height: 100%;
}



.backServicesFijo {
	z-index: -10;
	position: fixed;
	top: 0px;
	height: 2200px;
	width: 100%;
	left: 0px;

	background-image: url(../assets/img/header_home.jpg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
  .image {
  }
}

.services {
	position: relative;
	display: flex;
	flex-direction: column;
	//width: 100%;
	top: 10px;
	
	justify-content: flex-start;
	align-items: center;
	align-content: center;
	height: 100%;
	padding-bottom: 60px;
	
	@media @tablet {
		height: 80%;
	}
	@media @tablet {
		height: 80%;
	}
   
	.titulo { 
		display: flex;
		padding-top: 15px;
		//text-align: center;
		width: 130px;
		span {
			//flex: 1 0 100%;
			h1 {
				font-weight: 100;
				font-family: 'Raleway';
				font-size: 1.4em;
				padding: 15px;
				border-top: 1px solid @color_Secundario_Logo;
				border-bottom: 1px solid @color_Secundario_Logo;
			}
		}
	}
	.serviceBox {
	
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		//border: 2px solid white;

		.contenidoServices {
			width: 300px;
			text-align: center;
			//margin-top: 40px;
			padding: 20px 40px;
			//border: 2px solid white;
			li {
				list-style: none;
			}
			@media @tablet {
				padding: 20px 10px;
			}
			@media @mobile {
				padding: 20px 0px;
			}

			.icono {
				//margin: auto;
				padding-top: 50px;
				// border: 2px solid white;
			}
			.titulo {
				width: 100%;
				font-size: 1.9em;
				text-align: center;
				//border: 2px solid white;
			}
			.subtitulo {
				width: 100%;
				font-weight: 300;
				font-size: 1.2em;
				text-align: center;
				padding-bottom: 20px;
				//border: 2px solid white;
			}
			.read {
				color: white;
				text-transform: uppercase;
				font-size: .8em;
				padding: 15px 30px;
				border-radius: 5px;
				background-color: #648175;
				transition: background-color .3s ease;
				&:hover {
					background-color: lighten(#648175, 5);
				}
			}

			.a {
				text-decoration: none;
			}
		} // end contenidoServices
	} // end serviceBox
}
</style>
